import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, viewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { SortableComponent } from 'ngx-bootstrap/sortable';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { Region } from '../../bo/region';
import { WorkflowEtapeModele } from '../../bo/workflowEtapeModele';
import { WorkflowModele } from '../../bo/workflowModele';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  selector: 'app-workflow-modele-modale',
  templateUrl: './workflow-modele-modale.component.html',
  styleUrls: ['./workflow-modele-modale.component.scss'],
  standalone: false
})

export class WorkflowModeleModaleComponent {
  readonly sortableComponent = viewChild<SortableComponent>('sortableComponent');
  readonly modalConfirmSuppr = viewChild<ModalDirective>('modalConfirmSuppr');
  readonly modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  readonly modalConfirmApply = viewChild<ModalDirective>('modalConfirmApply');
  nomInvalide = false;
  etapeNomObligatoire = false;
  estMiseJour: boolean;
  estRegion: boolean;
  regionId: number;
  success = false;
  successDelete = false;
  workflowModele: WorkflowModele;
  workflowModeleSauv: WorkflowModele;
  listeEtapeSauv = [];
  nomEtapeToAdd: string;
  itemStringsRight: any[] = [''];
  etapeObligatoire = false;
  erreurApi: boolean;
  tabRegions: Region[];
  regionSelectionnee: Region;

  constructor(public bsModalRef: BsModalRef, private readonly http: HttpService, private readonly utilService: UtilisateurService,
    private readonly fonctionsService: FonctionsService) { }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  ngOnInit() {
    this.workflowModeleSauv = new WorkflowModele();
    if (!this.estMiseJour) {
      this.workflowModele = new WorkflowModele();
      this.workflowModele.workflowModeleId = -1;
    } else {
      this.workflowModeleSauv = JSON.parse(JSON.stringify(this.workflowModele));
    }
    if (this.estRegion) {
      this.regionSelectionnee = this.tabRegions.filter(p => p.regionId == this.regionId)[0];
    }
  }

  disableDrag(e: any) {
    e.returnValue = false;
    e.preventDefault();
  }

  private updateWorkflow(): Observable<WorkflowModele> {
    this.erreurApi = false;
    if (this.validationFormulaire()) {
      this.workflowModele.nom = this.workflowModele.nom.trim();
      if (this.workflowModele.workflowEtapeModeles) {
        this.workflowModele.workflowEtapeModeles.forEach((etape, index) => {
          etape.numeroOrdre = index + 1;
          etape.nom = etape.nom.trim();
        });
      }

      if (this.estRegion){ //Modale ouverte depuis la vue workflow région
        this.workflowModele.regionId = this.regionSelectionnee.regionId;
      } 
      else{
        this.workflowModele.siteId = this.utilService.currentSite().siteId;
      }

      this.fonctionsService.loading_screen(true);
      var requete = null;

      if (!this.estRegion && this.workflowModele.regionId && this.estMiseJour) {
        this.workflowModele.workflowModeleParentId = this.workflowModele.workflowModeleId;
        this.workflowModele.workflowModeleId = 0;
        this.workflowModele.regionId = null;
        this.workflowModele.siteId = this.utilService.currentSite().siteId;

        requete = this.http.post<WorkflowModele, WorkflowModele>('WorkflowsModeles', this.workflowModele);
      }
      else {
        requete = this.estMiseJour ? this.http.put<WorkflowModele, WorkflowModele>('WorkflowsModeles', this.workflowModele) :
          this.http.post<WorkflowModele, WorkflowModele>('WorkflowsModeles', this.workflowModele);
      }
      return requete;
    }
    return null;
  }

  onSubmit() {
    var requete = this.updateWorkflow();
    if (null !== requete) {
      requete.subscribe(resultat => {
        this.fonctionsService.loading_screen(false);
        if (resultat) {
          this.workflowModele = resultat;
          this.success = true;
        }
        else
          this.erreurApi = true;
        if (!this.erreurApi) {
          this.fonctionsService.launch_toast(this.success);
          this.bsModalRef.hide();
        }
      }, () => {
        this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  delete() {
    this.fonctionsService.loading_screen(true);
    this.erreurApi = false;
    this.http.delete('WorkflowsModeles/' + this.workflowModele.workflowModeleId).subscribe(res => {
      this.fonctionsService.loading_screen(false);
      if (res)
        this.successDelete = true;
      else
        this.erreurApi = true;
      if (!this.erreurApi) {
        this.fonctionsService.launch_toast(this.successDelete, this.successDelete);
        this.bsModalRef.hide();
      }
    }, () => {
      this.fonctionsService.loading_screen(false);
      this.erreurApi = true;
    })
  }

  validationFormulaire() {
    this.etapeObligatoire = this.workflowModele.workflowEtapeModeles.length == 0;
    this.nomInvalide = this.fonctionsService.stringEstVide(this.workflowModele.nom);
    this.etapeNomObligatoire = this.workflowModele.workflowEtapeModeles.filter(o => !o.nom || !o.nom.trim()).length > 0;

    return !this.nomInvalide && !this.etapeObligatoire && !this.etapeNomObligatoire;
  }

  annulModif() {
    if (!this.estMiseJour)
      this.workflowModele.workflowModeleId = -1;
    else
      Object.assign(this.workflowModele, this.workflowModeleSauv);
    this.bsModalRef.hide();
  }

  showModalCancel() {
    if (this.diff())
      this.modalConfirmCancel().show();
    else
      this.annulModif();
  }

  diff() {
    if (this.estMiseJour) {
      if (this.workflowModele.nom != this.workflowModeleSauv.nom) return true;
      if (this.workflowModele.workflowEtapeModeles.length != this.workflowModeleSauv.workflowEtapeModeles.length) return true;

      for (let i = 0; i < this.workflowModele.workflowEtapeModeles.length; i++) {
        if (this.workflowModele.workflowEtapeModeles[i].nom != this.workflowModeleSauv.workflowEtapeModeles[i].nom || this.workflowModele.workflowEtapeModeles[i].numeroOrdre != this.workflowModeleSauv.workflowEtapeModeles[i].numeroOrdre) {
          return true;
        }
      }
    }
    else
      return this.workflowModele.nom ||
        (this.workflowModele.workflowEtapeModeles && this.workflowModele.workflowEtapeModeles.length > 0);
  }

  showModalSuppr() {
    this.modalConfirmSuppr().show();
  }

  showModalApplyToAll() {
    this.modalConfirmApply().show();
  }

  annulSuppr() {
    this.modalConfirmSuppr().hide();
  }

  ApplyWorkflowToAll() {
    this.modalConfirmApply().hide();

    var updateRequest = this.updateWorkflow();
    if (null !== updateRequest) {
      updateRequest.subscribe(resultat => {
        if (resultat) {
          this.workflowModele = resultat;
          this.success = true;
        }
        else {
          this.fonctionsService.loading_screen(false);
          this.erreurApi = true;
        }

        if (!this.erreurApi) {
          var regionId = this.regionSelectionnee.regionId;
          this.http.put<WorkflowModele, WorkflowModele>('Regions/AffectToRegion/' + regionId, this.workflowModele)
            .subscribe(resultat => {
              this.fonctionsService.loading_screen(false);
              this.fonctionsService.launch_toast(this.success);
            });
        }
      });
    }
  }

  addEtape() {
    if (this.nomEtapeToAdd && this.nomEtapeToAdd.trim()) {
      var wm = new WorkflowEtapeModele();
      wm.nom = this.nomEtapeToAdd.trim();
      wm.numeroOrdre = this.workflowModele.workflowEtapeModeles.length + 1;
      this.workflowModele.workflowEtapeModeles.push(wm);
      this.sortableComponent().writeValue(this.workflowModele.workflowEtapeModeles);
      this.nomEtapeToAdd = "";
    }
    document.getElementById('nomEtapeToAdd').focus();
  }

  deleteItem(el: WorkflowEtapeModele) {
    var index = this.workflowModele.workflowEtapeModeles.findIndex(p => p.nom == el.nom && p.numeroOrdre == el.numeroOrdre);
    this.workflowModele.workflowEtapeModeles.splice(index, 1);
    this.sortableComponent().writeValue(this.workflowModele.workflowEtapeModeles);
  }

}
